// extracted by mini-css-extract-plugin
export var alignBaseline = "_16-9";
export var alignCenter = "_16-5";
export var alignFlexEnd = "_16-7";
export var alignFlexStart = "_16-6";
export var alignSelfBaseline = "_16-e";
export var alignSelfCenter = "_16-a";
export var alignSelfFlexEnd = "_16-c";
export var alignSelfFlexStart = "_16-b";
export var alignSelfStretch = "_16-d";
export var alignStretch = "_16-8";
export var column = "_16-2";
export var columnReverse = "_16-4";
export var flex = "_16-0";
export var justifyCenter = "_16-f";
export var justifyFlexEnd = "_16-h";
export var justifyFlexStart = "_16-g";
export var justifySpaceAround = "_16-j";
export var justifySpaceBetween = "_16-i";
export var justifySpaceEvenly = "_16-k";
export var row = "_16-1";
export var rowReverse = "_16-3";
export var wrapNowrap = "_16-m";
export var wrapWrap = "_16-l";
export var wrapWrapReverse = "_16-n";